import React from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { access, defaultRoute, getOrganizatorFromRoles, getPrepodavatelFromRoles, getShkolaFromRoles } from '../../../../common/Tool';
import { QueryDetail, QueryParam, useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { BreadcrumbsProvider, MenuLevelTwoContext, useNearestObjectContext } from '../../../../common/Context';
import PromoRole from './PromoRole';
import { ContextRoleElement } from '../../../components/ContextElement';
import { useCallback } from 'react';
import { Empty } from 'antd';
import ContextRoute, { ContextGroup, ContextGroupItem } from '../../ContextRoute';
import ObjectVtpDescription from '../../../../fedance-ui/ObjectVtpDescription';
import EventListItem from '../../../components/EventListItem';

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

export default function Promo(props) {
	let { id } = useParams();
	const dispatch = useDispatch();
	let navigate = useNavigate();
	const auth = useAuth();
	const t = useTranslateContext();
	const user = useUserContext();
	const meta = useMetaContext();
	const [userConfig, setUserConfig] = useUserConfigContext();
	// const langSwitch = useLangSwitchContext();

	const siteAccess = useSelector(state => state.siteAccess.value);

	const role_by_id = useSelector(state => state.home.role_by_id);
	const status = useSelector(state => state.home.status, () => { }); // Статусы
	const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

	const [event, setContextObject] = useNearestObjectContext()

	const allVTP = useSelector(state => state.home.role);

	const prepodavatel = useSelector(getPrepodavatelFromRoles(["ПреподавательФедерации"])); // Преподаватель
	const shkola = useSelector(getShkolaFromRoles(["ВладелецШколыФедерации", "АдминистраторШколыФедерации"]));
	const organizator = useSelector(getOrganizatorFromRoles(["ОрганизаторФедерации", "АдминистраторОрганизатораФедерации"])); // Организатор
	const prepodavatelShkoli = useSelector(getShkolaFromRoles(["ПреподавательШколы"]));

	// console.log(id, event, prepodavatel, shkola, organizator, prepodavatelShkoli);
	// let ID = _.get(shkola[0], "_role.ID");

	const chunk = (myArray, chunk_size) => {
		if (chunk_size <= 0) {
			return myArray
		}
		var a = (myArray) ? myArray : [];
		var index = 0;
		var arrayLength = a?.length;
		var tempArray = [];
		for (index = 0; index < arrayLength; index += chunk_size) {
			var myChunk = a.slice(index, index + chunk_size);
			if (myChunk && myChunk?.length)
				tempArray.push(myChunk);
		}
		return tempArray;
	}
	// const c = chunk(sortByFilters(filters, filterByFilters(filters, data)), (noPagination === true) ? data.length : count);
	// const page = (c.length >= current) ? c[current - 1] : (c.length !== 0) ? c[0] : [];

	const sourcePrepodavatel = useCallback(({
		lock,
		unlock,
		page,
		count,
		sorting,
		filter,
		apply
	}) => {
		// const c = chunk(sortByFilters(filters, filterByFilters(filters, data)), (noPagination === true) ? data.length : count);
		const c = (prepodavatel && prepodavatel?.length) ? chunk(prepodavatel, count) : [];
		const cpage = (c.length >= page) ? c[page - 1] : (c.length !== 0) ? c[0] : [];
		apply({
			// stat,
			totalPages: c?.length,
			size: count,
			totalElements: (prepodavatel) ? prepodavatel?.length : 0,
			content: (!count) ? prepodavatel : cpage
		})
	}, [prepodavatel])

	const sourceShkola = useCallback(({
		lock,
		unlock,
		page,
		count,
		sorting,
		filter,
		apply
	}) => {
		// const c = chunk(sortByFilters(filters, filterByFilters(filters, data)), (noPagination === true) ? data.length : count);
		const c = (shkola && shkola?.length) ? chunk(shkola, count) : [];
		const cpage = (c.length >= page) ? c[page - 1] : (c.length !== 0) ? c[0] : [];
		apply({
			// stat,
			totalPages: c?.length,
			size: count,
			totalElements: (shkola) ? shkola?.length : 0,
			content: (!count) ? shkola : cpage
		})
	}, [shkola])

	const sourceOrganizator = useCallback(({
		lock,
		unlock,
		page,
		count,
		sorting,
		filter,
		apply
	}) => {
		// const c = chunk(sortByFilters(filters, filterByFilters(filters, data)), (noPagination === true) ? data.length : count);
		const c = (organizator && organizator?.length) ? chunk(organizator, count) : [];
		const cpage = (c.length >= page) ? c[page - 1] : (c.length !== 0) ? c[0] : [];
		apply({
			// stat,
			totalPages: c?.length,
			size: count,
			totalElements: (organizator) ? organizator?.length : 0,
			content: (!count) ? organizator : cpage
		})
	}, [organizator])

	const sourcePrepodavatelShkoli = useCallback(({
		lock,
		unlock,
		page,
		count,
		sorting,
		filter,
		apply
	}) => {
		// const c = chunk(sortByFilters(filters, filterByFilters(filters, data)), (noPagination === true) ? data.length : count);
		const c = (prepodavatelShkoli && prepodavatelShkoli?.length) ? chunk(prepodavatelShkoli, count) : [];
		const cpage = (c.length >= page) ? c[page - 1] : (c.length !== 0) ? c[0] : [];
		apply({
			// stat,
			totalPages: c?.length,
			size: count,
			totalElements: (prepodavatelShkoli) ? prepodavatelShkoli?.length : 0,
			content: (!count) ? prepodavatelShkoli : cpage
		})
	}, [prepodavatelShkoli])

	const sourceAll = useCallback(({
		lock,
		unlock,
		page,
		count,
		sorting,
		filter,
		apply
	}) => {
		// const c = chunk(sortByFilters(filters, filterByFilters(filters, data)), (noPagination === true) ? data.length : count);
		const c = (allVTP && allVTP?.length) ? chunk(allVTP, count) : [];
		const cpage = (c.length >= page) ? c[page - 1] : (c.length !== 0) ? c[0] : [];
		apply({
			// stat,
			totalPages: c?.length,
			size: count,
			totalElements: (allVTP) ? allVTP?.length : 0,
			content: (!count) ? allVTP : cpage
		})
	}, [allVTP])

	// console.log(allVTP);
	const menu = (status, notify) => {
		const x = [
			{
				uuid: "role",
				default: true,
				name: "Выбор получателя",
				component: (props) => (
					<ContextRoute uuid=":id"
						display={(item) => <ContextRoleElement item={item} color={"#FF7900"} />}
						displayString={(item) => <ObjectVtpDescription object={item} inline={true} />}

						list={<ContextGroup
							style={{ height: "100%", overflow: "auto", flex: "auto" }}
							grouptitle={<div style={{ fontSize: "16px" }}>
								<EventListItem
									key={"event"}
									event={event}
									hideRoles={true}
									hidePreview={true}
									noNameLink={true}
									hideBuyButton={true}
									hideDetailButton={true}
									size="small"
								/>
								{((organizator && organizator.length > 0) ||
									(shkola && shkola.length > 0) ||
									(prepodavatel && prepodavatel.length > 0) ||
									(prepodavatelShkoli && prepodavatelShkoli.length > 0)
								) && <div style={{ padding: "20px 0 10px 10px" }}>Выберите получателя промокода</div>}
							</div>}
						>
							{(organizator && organizator.length > 0) && <ContextGroupItem {...props}
								// count={() => (5)}
								source={sourceOrganizator}
								title={<div style={{ padding: "10px 7px", fontSize: "16px" }}>
									<div>Организатор</div>
								</div>}
								empty={<div>Нет доступных ролей для получения промокода</div>}
							/>}
							{(shkola && shkola.length > 0) && <ContextGroupItem {...props}
								source={sourceShkola}
								title={<div style={{ padding: "10px 7px", fontSize: "16px" }}>
									<div>Школа</div>
								</div>}
								empty={<div>Нет доступных ролей для получения промокода</div>}
							/>}
							{(prepodavatel && prepodavatel.length > 0) && <ContextGroupItem {...props}
								source={sourcePrepodavatel}
								title={<div style={{ padding: "10px 7px", fontSize: "16px" }}>
									<div>Преподаватель федерации</div>
								</div>}
								empty={<div>Нет доступных ролей для получения промокода</div>}
							/>}
							{(prepodavatelShkoli && prepodavatelShkoli.length > 0) && <ContextGroupItem {...props}
								source={sourcePrepodavatelShkoli}
								title={<div style={{ padding: "10px 7px", fontSize: "16px" }}>
									<div>Преподаватель школы</div>
								</div>}
								empty={<div>Нет доступных ролей для получения промокода</div>}
							/>}
							{(!(organizator && organizator.length > 0) &&
								!(shkola && shkola.length > 0) &&
								!(prepodavatel && prepodavatel.length > 0) &&
								!(prepodavatelShkoli && prepodavatelShkoli.length > 0)
							) && <div>
									<div>
										<Empty description={"У вас нет подходящих ролей для получения промокода по мероприятию"} style={{ padding: "40px 0px" }} /></div>
								</div>}
						</ContextGroup>}

						itemSource={sourceAll}
						item={<PromoRole {...props} event={event} />}
					/>
				),
				role: [
					{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
				],
			},
			// {
			// 	uuid: "*",
			// 	name: "Error404",
			// 	unvisible: true,
			// 	component: (props) => (
			// 		<Error404 />),
			// 	role: [
			// 		{ "ID": 4, "nazvanie": "ОбычныйПользователь" },
			// 	],
			// }
			// {
			//     uuid: "error",
			//     name: "Ошибка получения промокода",
			// 	unvisible: true,
			//     component: (props) => (<Error {...props} />),
			//     role: [
			//         { "ID": 4, "nazvanie": "ОбычныйПользователь" },
			//     ],
			// },
		]
		return x
	};

	return (
		<MenuLevelTwoContext.Provider value={menu(status, notify)}>
			{(!siteAccess || siteAccess == "allow") && <Routes>
				{defaultRoute(menu(status, notify), role_by_id)}
				{menu(status, notify).map((e, idx) => {
					if (e.component && access(e, role_by_id)) {
						return <Route key={e.uuid} path={(e.uuid !== "*") ? e.uuid + "/*" : "*"} element={
							<BreadcrumbsProvider value={{
								// parent: props?.level,
								uuid: e?.uuid,
								name: e?.name,
								color: e?.color,
								role: e?.role,
								hidden: e.hidden
							}}>
								{e.component({})}
							</BreadcrumbsProvider>}
						/>
					}
				})}
			</Routes>}
		</MenuLevelTwoContext.Provider>
	);
}
